import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/trucks-for-sale-euro-6-and-leasing/")({
  head: () => routeHead("/uk/trucks-for-sale-euro-6-and-leasing/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/trucks", statusCode: 301, replace: true });
  },
});
